<table
  mat-table
  [dataSource]="result"
  multiTemplateDataRows
  class="mat-elevation-z8"
>
  <ng-container matColumnDef="accountManagerName">
    <th mat-header-cell class="header" *matHeaderCellDef>Nome do Gestor</th>
    <td mat-cell *matCellDef="let errors">
      {{ errors.accountManagerName }}
    </td>
  </ng-container>

  <ng-container matColumnDef="accountManagerDocument">
    <th mat-header-cell class="header" *matHeaderCellDef>CNPJ Gestor</th>
    <td mat-cell *matCellDef="let element">
      {{ element.accountManagerDocument }}
    </td>
  </ng-container>

  <ng-container matColumnDef="portfolioDocument">
    <th mat-header-cell class="header" *matHeaderCellDef>CNPJ</th>
    <td mat-cell *matCellDef="let element">
      {{ element.portfolioDocument }}
    </td>
  </ng-container>

  <ng-container matColumnDef="portfolioBank">
    <th mat-header-cell class="header" *matHeaderCellDef>Banco</th>
    <td mat-cell *matCellDef="let element">
      {{ element.fundBank }}
    </td>
  </ng-container>

  <ng-container matColumnDef="portfolioBranch">
    <th mat-header-cell class="header" *matHeaderCellDef>Agência</th>
    <td mat-cell *matCellDef="let element">
      {{ element.fundBranch }}
    </td>
  </ng-container>

  <ng-container matColumnDef="portfolioAccount">
    <th mat-header-cell class="header" *matHeaderCellDef>Conta Corrente</th>
    <td mat-cell *matCellDef="let element">
      {{ element.portfolioAccount }}
    </td>
  </ng-container>

  <ng-container matColumnDef="portfolioName">
    <th mat-header-cell class="header" *matHeaderCellDef>Nome do Fundo</th>
    <td mat-cell *matCellDef="let element">
      {{ element.portfolioName }}
    </td>
  </ng-container>

  <ng-container matColumnDef="portfolioSelicAccount">
    <th mat-header-cell class="header" *matHeaderCellDef>Conta Selic</th>
    <td mat-cell *matCellDef="let element">
      {{ element.portfolioSelicAccount }}
    </td>
  </ng-container>

  <ng-container matColumnDef="operationTypeId">
    <th mat-header-cell class="header" *matHeaderCellDef>Tipo de Operação</th>
    <td mat-cell *matCellDef="let element">
      {{ element.operationTypeId }}
    </td>
  </ng-container>

  <ng-container matColumnDef="returnDate">
    <th mat-header-cell class="header" *matHeaderCellDef>Data de Retorno</th>
    <td mat-cell *matCellDef="let element">
      {{ element.returnDate | date: "dd/MM/yyyy" }}
    </td>
  </ng-container>

  <ng-container matColumnDef="unitPriceOutward">
    <th mat-header-cell class="header" *matHeaderCellDef>PU Ida</th>
    <td mat-cell *matCellDef="let element">
      {{ element.unitPriceOutward | number }}
    </td>
  </ng-container>

  <ng-container matColumnDef="unitPriceReturn">
    <th mat-header-cell class="header" *matHeaderCellDef>PU Volta</th>
    <td mat-cell *matCellDef="let element">
      {{ element.unitPriceReturn | number }}
    </td>
  </ng-container>

  <ng-container matColumnDef="valueOutward">
    <th mat-header-cell class="header" *matHeaderCellDef>Valor Ida</th>
    <td mat-cell *matCellDef="let element">
      {{ element.valueOutward | currency: "R$":"symbol":"1.2-2" }}
    </td>
  </ng-container>

  <ng-container matColumnDef="valueReturn">
    <th mat-header-cell class="header" *matHeaderCellDef>Valor Volta</th>
    <td mat-cell *matCellDef="let element">
      {{ element.valueReturn | currency: "R$":"symbol":"1.2-2" }}
    </td>
  </ng-container>

  <ng-container matColumnDef="amount">
    <th mat-header-cell class="header" *matHeaderCellDef>Quantidade</th>
    <td mat-cell *matCellDef="let element">
      {{ element.amount | number }}
    </td>
  </ng-container>

  <ng-container matColumnDef="operationValue">
    <th mat-header-cell class="header" *matHeaderCellDef>Valor da Operação</th>
    <td mat-cell *matCellDef="let element">
      {{ element.operationValue | currency: "R$":"symbol":"1.2-2" }}
    </td>
  </ng-container>

  <ng-container matColumnDef="security">
    <th mat-header-cell class="header" *matHeaderCellDef>Título</th>
    <td mat-cell *matCellDef="let element">
      {{ element.security }}
    </td>
  </ng-container>

  <ng-container matColumnDef="securityId">
    <th mat-header-cell class="header" *matHeaderCellDef>Código do Título</th>
    <td mat-cell *matCellDef="let element">
      {{ element.securityId }}
    </td>
  </ng-container>

  <ng-container matColumnDef="expirationDate">
    <th mat-header-cell class="header" *matHeaderCellDef>Data Vencimento</th>
    <td mat-cell *matCellDef="let element">
      {{ element.expirationDate | date: "dd/MM/yyyy" }}
    </td>
  </ng-container>

  <ng-container matColumnDef="issueTax">
    <th mat-header-cell class="header" *matHeaderCellDef>Taxa Emissão</th>
    <td mat-cell *matCellDef="let element">
      {{ element.issueTax }}
    </td>
  </ng-container>

  <ng-container matColumnDef="counterpartName">
    <th mat-header-cell class="header" *matHeaderCellDef>Nome Contraparte</th>
    <td mat-cell *matCellDef="let element">
      {{ element.counterpartName }}
    </td>
  </ng-container>

  <ng-container matColumnDef="counterpartDocument">
    <th mat-header-cell class="header" *matHeaderCellDef>CNPJ Contraparte</th>
    <td mat-cell *matCellDef="let element">
      {{ element.counterpartDocument }}
    </td>
  </ng-container>

  <ng-container matColumnDef="counterpartSelicAccount">
    <th mat-header-cell class="header" *matHeaderCellDef>
      Conta SELIC / CETIP da contraparte
    </th>
    <td mat-cell *matCellDef="let element">
      {{ element.counterpartSelicAccount }}
    </td>
  </ng-container>

  <ng-container matColumnDef="command">
    <th mat-header-cell class="header" *matHeaderCellDef>Comando</th>
    <td mat-cell *matCellDef="let element">
      {{ element.command }}
    </td>
  </ng-container>

  <ng-container matColumnDef="annotations">
    <th mat-header-cell class="header" *matHeaderCellDef>Observação</th>
    <td mat-cell *matCellDef="let element">
      {{ element.annotations }}
    </td>
  </ng-container>

  <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
  <ng-container matColumnDef="expandedDetail">
    <td
      mat-cell
      *matCellDef="let element"
      [attr.colspan]="ColumnsContracted.length"
    >
      <div
        class="example-element-detail"
        [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'"
      >
        <div class="example-element-description">
          <h4>Erros encontrados:</h4>
          <ul *ngFor="let error of element.errors">
            <li>
              {{ error }}
            </li>
          </ul>
        </div>
      </div>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="ColumnsContracted"></tr>
  <tr
    mat-row
    *matRowDef="let element; columns: ColumnsContracted"
    class="example-element-row"
    [class.example-expanded-row]="expandedElement === element"
    (click)="expandedElement = expandedElement === element ? null : element"
  ></tr>
  <tr
    mat-row
    *matRowDef="let row; columns: ['expandedDetail']"
    class="example-detail-row"
  ></tr>
</table>
